module.exports = __webpack_public_path__ + "img/Blog-Image@2x.e32b4fd5.png";